angular.module('dpw.services').factory('dpwUserRoleService', ['$q', 'user', function ($q, user) {
    var UserRole = {
        Administrator: 'Administrator',
        Developer: 'Developer',
        Audit: 'Audit'
    };

    var userRoleConfig = {};

    userRoleConfig[UserRole.Administrator] = {
        id: UserRole.Administrator,
        label: 'Developer Admin',
        desc: RCDPW.Lang.MyAccount.RolePermission.ROLE_DESC_ADMIN,
        showAppAccessSettings: false
    };

    userRoleConfig[UserRole.Developer] = {
        id: UserRole.Developer,
        label: 'Developer',
        desc: RCDPW.Lang.MyAccount.RolePermission.ROLE_DESC_DEVELOPER,
        showAppAccessSettings: true
    };

    userRoleConfig[UserRole.Audit] = {
        id: UserRole.Audit,
        label: 'Audit',
        desc: RCDPW.Lang.MyAccount.RolePermission.ROLE_DESC_AUDIT,
        showAppAccessSettings: false
    };

    return {
        UserRole: UserRole,
        getConfig: getConfig,
        getCurrentUserRole: getCurrentUserRole,
        getUserRoleById: getUserRoleById
    };

    function getConfig() {
        return _.map(UserRole, function (roleId) {
            return userRoleConfig[roleId];
        });
    }

    function getCurrentUserRole() {
        return $q(function (resolve) {
            user.fetch().then(function () {
                var currentUser = user.getUser();
                resolve(currentUser.role);
            });
        });
    }

    function getUserRoleById(id) {
        return userRoleConfig[id];
    }
}]);
